import gql from 'graphql-tag';

import { baseImageGraphqlFields } from '#src/lib/wb-asset/image-graphql-fields';

// Shared between invite-landing.js (invite by token) and
// use-supercharger-game-query.js (game by id) - both feed the exact same
// SuperchargerGameSummary/SocialMetaTags rendering, so their field
// selections must stay identical. Requires the querying operation to
// declare $timeZone: String! (used by joinability below) and
// $isAuthenticated: Boolean! (used by userStatusV2 below).
export const superchargerGameFieldsFragment = gql`
  fragment SuperchargerGameFieldsFragment on FalkorGame {
    isTeamGame
    betAmount
    # A trial game (selectIsTrialGame) shows no earnback.
    trialJoin
    phase
    startDate
    endDate
    joinPeriodEndAt
    joinability(timeZone: $timeZone) {
      joinable
      code
    }
    # Only requested when authenticated - userStatusV2's resolver resolves
    # the caller off the JWT and 500s for an anonymous one with no userId
    # argument (wb-graphql-service's FalkorGame.userStatusV2 does
    # userId || jwtData.sub).
    userStatusV2 @include(if: $isAuthenticated) {
      isPlayer
    }
    displayCategory
    subtypeVariation
    title
    description
    # The landing page's own copy and its page title/share overrides,
    # blank when unset - see SuperchargerGameSummary and
    # selectSuperchargerLandingMeta.
    landingPage {
      headline
      whoThisIsFor
      summaryLine
      pageTitle
      shareTitle
      shareDescription
      shareImage
    }
    requiredMetricCount
    subroundDetails {
      numSubroundsPerRound
    }
    rules {
      heading
      body {
        html
      }
    }
    image {
      ${baseImageGraphqlFields}
    }
    superchargerHeroMedia {
      ... on Cloudinary {
        ${baseImageGraphqlFields}
        resourceType
      }
    }
    stats {
      playerCount
      potAmount
    }
    hosts {
      id
      bio
      isOfficialCoach
      avatarV2 {
        value
        type
      }
    }
    superchargerMessaging {
      notifications
      smsHost {
        id
        firstName
        bio
        avatarV2 {
          value
          type
        }
        # The host's own page video (the one their text club shows), for
        # a game without a hero video of its own - see Hero.
        superchargerHost {
          heroMedia {
            ... on Cloudinary {
              ${baseImageGraphqlFields}
              resourceType
            }
          }
        }
      }
    }
    publicPlayerList(paging: { limit: 12 }) {
      edges {
        id
        userId
        firstName
        avatarV2 {
          value
          type
        }
      }
    }
  }
`;
